import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Tab, Nav,Col } from "react-bootstrap";
import {Table, Search, FormFields, AsyncSelectFields, SelectFields, ButtonFields, ButtonResetFields, ModalComponents, InputFields, Loading } from '../../components/Index';
import { getEstado, getEstadoTramite, getListaServicio, getListarActividadEstado, CrearActividadEstadoPedido, ActualizarNota, CrearActividadEstadoTramitePedido, getListarActividadEstadoTramite } from '../../services/SalesServices';
import { getComboCliente, getComboFallecido } from '../../services/PersonServices';
import UserPermissionsComponent from '../auth/UserPermissionsComponent';
import { showErrorAlert, showSuccessAlert, showConfirAlert } from '../../utils/helper/AlertService';
import { avanceEstadoSchema, avanceEstadoTramiteSchema } from '../../utils/validations/ServiceValidation';
import useFormatMoney from '../../hooks/useFomatMoney';

const estadoDeuda = [
    {value:"01", label:"Con Deuda"},
    {value:"02", label:"Sin Deuda"}
]

const search = {
    skip: 1,
    take: 10,
    search: "",
    clienteId: "",
    finadoId: "",
    estadoId: "",
    estadoTramiteId: "",
    codigoDeuda:"",
    deudaEfectiva:"",
    fechaInicio:"",
    fechaFin: "",
    tipoServicioId:'D4521A44-AE7E-4A62-8797-B6C52E620488'
}

const modelInicial = {
    pedidoId: "",
    estadoId: "",
    comentario: "",
}

const modelInicialNota = {
    pedidoId: "",
    nota: "",
}

const modelInicialEstadoTramite = {
    pedidoId: "",
    estadoTramiteId: "",
    comentario: "",
}

function ListSales() {
    const [ serviciosPag, setServiciosPag ] = useState({});
    const [ listaServicio, setListaServiciosPag ] = useState([]);
    const [ paramSearch, setParamSearch ] = useState(search);
    const [ estado, setEstado ] = useState([]);
    const [ estadoTramite, setEstadoTramite ] = useState([]);
    const [ mdEstado, setMdEstado ] = useState(false);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ actividadEstado, setActividadEstado ] = useState([]);
    const [ actividadEstadoTramite, setActividadEstadoTramite ] = useState([]);
    const [ modelActividad, setModelActividad ] = useState(modelInicial);
    const [ mdNota, setMdNota ] = useState(false);
    const [ modelNota, setModelNota] = useState(modelInicialNota);
    const [ modelEstadoTramite, setModelEstadoTramite] = useState(modelInicialEstadoTramite);
    const { formatterMoney } = useFormatMoney();

    const onClickGuardar = (values,onSubmitProps) => {
        showConfirAlert({
            title: "Desea Actualizar el estado",
            text: "Verifique que todos los campos esten registrados correctamente",
            preConfirm: () => {
                CrearActividadEstadoPedido(values).then(() => {
                    showSuccessAlert('Registro Exitoso');
                    onSubmitProps.setSubmitting(false)
                    onSubmitProps.resetForm();
                    getData(paramSearch);
                    setMdEstado(false);
                }).catch((error) => {
                    showErrorAlert('Hubo un problema de registro',  error.apiMessage || 'Error desconocido');
                });
            }
        });
    }

    const onClickGuardarEstadoTramite = (values,onSubmitProps) => {
        showConfirAlert({
            title: "Desea Actualizar el Estado Tramite",
            text: "Verifique que todos los campos esten registrados correctamente",
            preConfirm: () => {
                CrearActividadEstadoTramitePedido(values).then(() => {
                    showSuccessAlert('Registro Exitoso');
                    onSubmitProps.setSubmitting(false)
                    onSubmitProps.resetForm();
                    getData(paramSearch);
                    setMdEstado(false);
                }).catch((error) => {
                    showErrorAlert('Hubo un problema de registro',  error.apiMessage || 'Error desconocido');
                });
            }
        });
    }

    const onClickGuardarNota = (values,onSubmitProps) => {
        showConfirAlert({
            title: "Desea Ingresar una Nota",
            text: "Verifique que todos los campos esten registrados correctamente",
            preConfirm: () => {
                ActualizarNota(values).then(() => {
                    showSuccessAlert('Registro Exitoso');
                    onSubmitProps.setSubmitting(false)
                    onSubmitProps.resetForm();
                    getData(paramSearch);
                    setMdNota(false);
                }).catch((error) => {
                    showErrorAlert('Hubo un problema de registro',  error.apiMessage || 'Error desconocido');
                });
            }
        });
    }

    const onClickEstado = async (id) => {
        setMdEstado(true);
        setModelActividad({...modelActividad, pedidoId: id})
        const actividad = await getListarActividadEstado(id);
        const actividadTramite = await getListarActividadEstadoTramite(id);
        setActividadEstado(actividad);
        setActividadEstadoTramite(actividadTramite);
        setModelEstadoTramite({...modelEstadoTramite,pedidoId: id})
    }

    const onClickNota = async (item) => {
        setMdNota(true);
        setModelNota({...modelNota,
            pedidoId: item.id,
            nota: item.nota
        })

    }

    const onInputSearch = ({target}) => {
        const { value } = target;
        setParamSearch({...paramSearch, search: value})
    }

    const fechDataClient = async (value) => {
        const resp_cliente = await getComboCliente(value);
        return resp_cliente;
    }

    const fechDataDeceased = async (value) => {
        const resp_cliente = await getComboFallecido(value);
        return resp_cliente;
    }

    const fechSatatus = async () => {
        let data = await getEstado(1);
        let estadoTramite = await getEstadoTramite();
        setEstado(data);
        setEstadoTramite(estadoTramite);
    }

    const handleTableChange = (page, sizePerPage) => {
        setParamSearch({
            ...paramSearch,
            skip:sizePerPage.page,
            take:sizePerPage.sizePerPage,
        })
    }

    const getData = async (param) => {
        try{
            setIsLoading(true);
            const data = await getListaServicio(param);
            setIsLoading(false);
            setServiciosPag(data);
            setListaServiciosPag(data.items);
        }
        catch(e){

        }

    }

    useEffect(() => {
        fechSatatus();
    },[])

    useEffect(() => {
        getData(paramSearch);
    },[paramSearch])

    const columns = [
        {
            dataField: "numeroContratoFisico",
            text: "N° FISC",
        },
        {
            dataField: "numeroContrato",
            text: "NRO",
        },
        {
            dataField: "fechaContrato",
            text: "Fecha"
        },
        {
            dataField: "tipoSeguro",
            text: "Seguro",
        },
        {
            dataField: "nombreCliente",
            text: "Cliente",
        },
        {
            dataField: "nombreFinado",
            text: "Finado"
        },
        {
            dataField: "coberturaSeguro",
            text: "Seguro(S/.)",
            align: 'right',
            formatter: (_, row) => (<p className="text-primary m-0">{formatterMoney(row.coberturaSeguro)}</p>)
        },
        {
            dataField: "precioNeto",
            text: "Efectivo",
            align: 'right',
            formatter: (_, row) => (<p className="text-primary m-0">{formatterMoney(row.precioNeto)}</p>)
        },
        {
            dataField: "deuda",
            text: "Deuda",
            align: 'right',
            formatter: (cellContent, row) => {
                if (cellContent === 0) {
                    return (
                        <p className="text-primary m-0">Sin Deuda</p>
                    );
                } else if (cellContent > 0 ) {
                    return (
                        <p className="text-danger font-weight-bold m-0">{formatterMoney(row.deuda)}</p>
                    );
                }
            }
        },
        {
            dataField: "estadoCodigo",
            text: "Estado",
            classes: 'py-1',
            formatter: (cellContent, row) => {
                return (
                    <label className="badge m-0 text-white" style={{backgroundColor: row.colorEstado}}>{row.estado}</label>
                );

            }
        },
        {
            dataField: "deudaEfectiva",
            text: "D Efectiva",
            formatter: (cellContent, row) => {
                if (cellContent === 0) {
                    return (
                        <p className="text-primary m-0">Sin Deuda</p>
                    );
                } else if (cellContent > 0 ) {
                    return (
                        <p className="text-danger font-weight-bold m-0">{formatterMoney(row.deudaEfectiva)}</p>
                    );
                }
            }
        },
        {
            dataField: "nota",
            text: "Nota",
            style: { minWidth: '10rem', maxWidth: '3000px', wordWrap: 'break-word', whiteSpace: 'normal' }
        },
        {
            dataField: "estadoTramite",
            text: "Cargo",
            formatter: (_, row) => {
                return (
                    <p className="text-success font-weight-bold m-0">{row.estadoTramite}</p>
                );

            }
        },
        {
            dataField: "opciones",
            text: "Opciones",
            sort: false,
            align: 'center',
            classes: 'py-1',
            formatter: (_, row) => {
                return (
                    <div>
                        <Link className='text-decoration-none' to={"/services/details-sales/"+row.id}><i className="ti-eye text-primary mr-2" data-toggle="tooltip" data-placement="right" title="Detalle" style={{fontSize:'15px'}}/></Link>
                        <UserPermissionsComponent accion={['admin','admVenta']}>
                            <Link className='text-decoration-none'><i className="ti-write text-success mr-2" data-toggle="tooltip" data-placement="right" title="Cambiar Estado" style={{fontSize:'15px'}} onClick={() => onClickEstado(row.id)}/></Link>
                        </UserPermissionsComponent>
                        <Link className='text-decoration-none'><i className="ti-pencil-alt text-warning" data-toggle="tooltip" data-placement="right" title="Cambiar Estado" style={{fontSize:'15px'}} onClick={() => onClickNota(row)}/></Link>
                    </div>
                );
            }
        }

    ]

    return (
        <div>
            <Row>
                <div className="col-12">
                    <Card >
                        <Card.Body>
                            <div className="row mb-4 justify-content-between">
                                <div className = "col-lg-3 d-none d-sm-none d-md-block">
                                    <h4 className="card-title float-left mt-2">Lista Ventas</h4>
                                </div>
                                <div className = "col-ms-12 col-md-6 col-lg-6 mb-2 ">
                                    <Search
                                        onSearchInput={onInputSearch}
                                        nameInput='DNI (Cliente/fallecido) / N° Comp. / N° FISC'
                                        value={paramSearch.search}
                                        onRefesh={() => setParamSearch(search)}
                                    >
                                        <FormFields
                                            initialValues={paramSearch}
                                            onSubmit={(values) => setParamSearch(values)}
                                        >
                                            <div className='row'>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <AsyncSelectFields
                                                        label={"Cliente(a)"}
                                                        isRequired = {false}
                                                        name={"clienteId"}
                                                        loadOptions = {fechDataClient}
                                                    />
                                                </div>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <AsyncSelectFields
                                                        label={"Finado(a)"}
                                                        isRequired = {false}
                                                        name={"finadoId"}
                                                        loadOptions = {fechDataDeceased}
                                                    />
                                                </div>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <SelectFields
                                                        label={"Estado"}
                                                        name="estadoId"
                                                        isRequired={false}
                                                        data={estado.map(item => ({value:item.id, label: item.nombre }))}
                                                    />
                                                </div>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <SelectFields
                                                        label={"Estado Tramite"}
                                                        name="estadoTramiteId"
                                                        isRequired={false}
                                                        data={estadoTramite.map(item => ({value:item.id, label: item.nombre }))}
                                                    />
                                                </div>
                                                <div className='col-sm-12 col-md-6 col-lg-6'>
                                                    <InputFields
                                                        label={"Fecha de Entrega"}
                                                        type="date"
                                                        isRequired={false}
                                                        name="fechaInicio"
                                                        size = "sm"
                                                    />
                                                </div>
                                                <div className='col-sm-12 col-md-6 col-lg-6'>
                                                    <InputFields
                                                        label={"Fecha de Recojo"}
                                                        type="date"
                                                        isRequired={false}
                                                        name="fechaFin"
                                                        size = "sm"
                                                    />
                                                </div>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <SelectFields
                                                        label={"Deuda"}
                                                        name="codigoDeuda"
                                                        isRequired={false}
                                                        data={estadoDeuda}
                                                    />
                                                </div>
                                                <div className='col-ms-12 col-md-6 col-lg-6'>
                                                    <SelectFields
                                                        label={"Deuda Efectiva"}
                                                        name="deudaEfectiva"
                                                        isRequired={false}
                                                        data={estadoDeuda}
                                                    />
                                                </div>
                                                <div className='col-12'>
                                                    <ButtonFields title='Buscar'/>
                                                    <ButtonResetFields title='Limpiar' onClickCancel={() => setParamSearch(search)}/>
                                                </div>
                                            </div>
                                        </FormFields>
                                    </Search>
                                </div>
                                <div className="col-sm-12 col-md-3 col-lg-3">
                                    <UserPermissionsComponent accion={['admin','crearVenta','admVenta']}>
                                        <Link className="btn btn-outline-primary float-right" to="/services/create-sales">
                                            <i className="fa fa-plus mr-2"/>
                                            Nueva Venta
                                        </Link>
                                    </UserPermissionsComponent>
                                </div>
                            </div>
                            <Table
                                columns={columns}
                                list={listaServicio}
                                page={serviciosPag.page}
                                sizePerPage={paramSearch.take}
                                totalSize={serviciosPag.total}
                                onTableChange={handleTableChange}
                            />
                            <Loading isLoading={isLoading}/>
                            <ModalComponents
                                size='md'
                                titulo={"Estado"}
                                show={mdEstado}
                                hide={() => setMdEstado(false)}
                            >
                                <div className='row'>
                                    <div className="col-12">
                                        <div className="tab-pills-horizontal">
                                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                                <Row>
                                                    <Col xs={12}>
                                                        <Nav variant="pills" className="flex-column">
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="first" className="d-flex align-items-center">
                                                                    <i className="fa fa-list-ul text-danger pr-2"></i>
                                                                    Estado Actividad
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                            <Nav.Item>
                                                                <Nav.Link eventKey="second" className="d-flex align-items-center">
                                                                    <i className="fa fa-file-text text-success pr-2"></i>
                                                                    Estado Tramite
                                                                </Nav.Link>
                                                            </Nav.Item>
                                                        </Nav>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Tab.Content className='border-0 p-0 pt-3'>
                                                            <Tab.Pane eventKey="first">
                                                                <div className='row'>
                                                                    <div className='col-12'>
                                                                        <FormFields
                                                                            initialValues = {modelActividad}
                                                                            onSubmit = {(values, onSubmitProps) => onClickGuardar(values,onSubmitProps)}
                                                                            validationSchema = {avanceEstadoSchema}
                                                                        >
                                                                            <div className='row'>
                                                                                <div className='col-sm-6 col-md-5 col-lg-5' style={{zIndex:3}}>
                                                                                    <SelectFields
                                                                                        label={"Estado"}
                                                                                        name="estadoId"
                                                                                        data={estado.map(item => ({value:item.id, label: item.nombre }))}
                                                                                    />
                                                                                </div>
                                                                                <div className='col-sm-12 col-md-5 col-lg-5'>
                                                                                    <InputFields
                                                                                        label={"Comentario"}
                                                                                        as="textarea"
                                                                                        rows={1}
                                                                                        name="comentario"
                                                                                        size = "sm"
                                                                                        isRequired = {false}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-sm-6 col-md-2 col-lg-2' style={{marginTop:'20px'}}>
                                                                                    <ButtonFields
                                                                                        className='btn btn-primary float-right ml-3 btn-sm'
                                                                                        title = {"Guardar"}/>
                                                                                </div>
                                                                            </div>
                                                                        </FormFields>
                                                                    </div>
                                                                    <div className='col-12'>
                                                                        <div className="mt-4">
                                                                            <div className="timeline alin">
                                                                                {
                                                                                    actividadEstado && actividadEstado.map((item,index) => (
                                                                                        <div className="timeline-wrapper timeline-inverted timeline-wrapper-warning" style={{zIndex:1}} key={index}>
                                                                                            <div className="timeline-badge"></div>
                                                                                            <div className="timeline-panel p-2">
                                                                                                <div className="timeline-heading">
                                                                                                    <p className="text-primary text-uppercase float-right">{item.estado}</p>
                                                                                                    <p className="font-weight-bold">{item.nombreUsuario}</p>
                                                                                                </div>
                                                                                                <div className="timeline-body">
                                                                                                    <p className='text-dark text-break'>{item.comentario}</p>
                                                                                                </div>
                                                                                                <div className="timeline-footer d-flex align-items-center flex-wrap">
                                                                                                    <span className="ml-md-auto font-weight-bold">{item.fecha}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey="second">
                                                                <div className='row'>
                                                                    <div className='col-12'>
                                                                        <FormFields
                                                                            initialValues = {modelEstadoTramite}
                                                                            onSubmit = {(values, onSubmitProps) => onClickGuardarEstadoTramite(values,onSubmitProps)}
                                                                            validationSchema = {avanceEstadoTramiteSchema}
                                                                        >
                                                                            <div className='row'>
                                                                                <div className='col-sm-6 col-md-5 col-lg-5' style={{zIndex:3}}>
                                                                                    <SelectFields
                                                                                        label={"Estado Tramite"}
                                                                                        name="estadoTramiteId"
                                                                                        data={estadoTramite.map(item => ({value:item.id, label: item.nombre }))}
                                                                                    />
                                                                                </div>
                                                                                <div className='col-sm-12 col-md-5 col-lg-5'>
                                                                                    <InputFields
                                                                                        label={"Comentario"}
                                                                                        as="textarea"
                                                                                        rows={1}
                                                                                        name="comentario"
                                                                                        size = "sm"
                                                                                        isRequired = {false}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-sm-6 col-md-2 col-lg-2' style={{marginTop:'20px'}}>
                                                                                    <ButtonFields
                                                                                        className='btn btn-primary float-right ml-3 btn-sm'
                                                                                        title = {"Guardar"}/>
                                                                                </div>
                                                                            </div>
                                                                        </FormFields>
                                                                    </div>
                                                                    <div className='col-12'>
                                                                        <div className="mt-4">
                                                                            <div className="timeline alin">
                                                                                {
                                                                                    actividadEstadoTramite && actividadEstadoTramite.map((item,index) => (
                                                                                        <div className="timeline-wrapper timeline-inverted timeline-wrapper-warning" style={{zIndex:1}} key={index}>
                                                                                            <div className="timeline-badge"></div>
                                                                                            <div className="timeline-panel p-2">
                                                                                                <div className="timeline-heading">
                                                                                                    <p className="text-primary text-uppercase float-right">{item.estadoTramite}</p>
                                                                                                    <p className="font-weight-bold">{item.nombreUsuario}</p>
                                                                                                </div>
                                                                                                <div className="timeline-body">
                                                                                                    <p className='text-dark text-break'>{item.comentario}</p>
                                                                                                </div>
                                                                                                <div className="timeline-footer d-flex align-items-center flex-wrap">
                                                                                                    <span className="ml-md-auto font-weight-bold">{item.fecha}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </div>

                                    </div>
                                </div>
                            </ModalComponents>

                            {/* Comentario Nota */}
                            <ModalComponents
                                size='md'
                                titulo={"Actividad Nota"}
                                show={mdNota}
                                hide={() => setMdNota(false)}
                            >
                                <div className='row'>
                                    <div className='col-12'>
                                        <FormFields
                                            initialValues = {modelNota}
                                            onSubmit = {(values, onSubmitProps) => onClickGuardarNota(values,onSubmitProps)}
                                        >
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <InputFields
                                                        label={"Nota"}
                                                        as="textarea"
                                                        rows={1}
                                                        name="nota"
                                                        size = "sm"
                                                        isRequired = {false}
                                                    />
                                                </div>

                                                <div className='col-12'>
                                                    <ButtonFields title = {"Guardar"}/>
                                                </div>
                                            </div>
                                        </FormFields>
                                    </div>
                                </div>
                            </ModalComponents>
                        </Card.Body>
                    </Card>
                </div>
            </Row>
        </div>
    );
}

export default ListSales;